import FormattedMessage from 'I18n/components/FormattedMessage';
import { openNewTab } from 'ui-addon-upgrades/_core/common/navigation/url';
import { Button } from 'foundations-components/transitional/components/Button';
import { getAcademyTrialRedirectLink, getAcademyTrialRedirectLinkFromApiName } from '../../../../trial/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const TrialRedirectButton = ({
  buttonText,
  onClick = () => {},
  block = true,
  use = 'primary',
  upgradeData: {
    app,
    upgradeProduct,
    apiName
  }
}) => {
  const isLearningCenter = app === 'learning-center';
  const academyTrialRedirectLink = apiName ? getAcademyTrialRedirectLinkFromApiName(apiName) : upgradeProduct ? getAcademyTrialRedirectLink(upgradeProduct) : undefined;
  const handleClick = () => {
    if (isLearningCenter && academyTrialRedirectLink) {
      openNewTab(academyTrialRedirectLink);
    }
    onClick();
  };
  return /*#__PURE__*/_jsx(Button, {
    onClick: handleClick,
    external: isLearningCenter ? true : undefined,
    href: isLearningCenter ? academyTrialRedirectLink : undefined,
    block: block,
    use: use,
    children: buttonText || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.activationModal.getStarted"
    })
  });
};
export default TrialRedirectButton;